import BaseNotify from '@/components/BaseNotify/BaseNotify'

export default {
  install(Vue) {
    const component = new Vue(BaseNotify)
    document.querySelector('body').appendChild(component.$mount().$el)
    Vue.prototype.$notify = component.notify
  }
}
